/**
 * 블로그 시스템 타입 정의.
 *
 * 영구지침: docs/develop/seo/blog-spec.md §3, §4.2
 */

export type BlogCategory =
  | 'cost'
  | 'facility-selection'
  | 'policy'
  | 'guardian'
  | 'region'

export const BLOG_CATEGORY_LABELS: Record<BlogCategory, string> = {
  cost: '비용 가이드',
  'facility-selection': '시설 선택',
  policy: '요양 제도',
  guardian: '보호자 팁',
  region: '지역 가이드',
}

export const BLOG_CATEGORIES: BlogCategory[] = [
  'cost',
  'facility-selection',
  'policy',
  'guardian',
  'region',
]

export interface BlogCta {
  text: string
  link: string
  emoji?: string
}

export interface BlogFrontmatter {
  slug: string
  title: string
  category: BlogCategory
  publishedAt: string // YYYY-MM-DD
  updatedAt?: string
  author: string
  summary: string
  thumbnail?: string
  keywords?: string[]
  ctaPrimary?: BlogCta
  ctaSecondary?: BlogCta
}

export interface BlogPost extends BlogFrontmatter {
  /** 본문 마크다운 (frontmatter 제외) */
  content: string
}
